import {Component, Input} from '@angular/core';
import {Signaalkaart} from '../signaalkaart';
import {Client} from '../../client/client';
import {SignaalkaartAntwoord} from '../signaalkaart-antwoord';

@Component({
    selector: 'zah-signaalkaart-antwoord-header',
    templateUrl: './signaalkaart-antwoord-header.component.html',
    styleUrls: ['./signaalkaart-antwoord-header.component.scss'],
    standalone: false
})
export class SignaalkaartAntwoordHeaderComponent {

  @Input()
  signaalkaart: Signaalkaart;
  @Input()
  signaalkaartAntwoord: SignaalkaartAntwoord;
  @Input()
  client: Client;
}
